/**
 * The dashboard's fixed numbers (HS-1501), in the one file kind `no-magic-numbers` exempts.
 */

/** The period select's options, in days — the Figma shows "7 days"; 14 and 30 widen it. */
export const DASHBOARD_PERIODS = [7, 14, 30] as const;

export type DashboardPeriod = (typeof DASHBOARD_PERIODS)[number];

export const DEFAULT_DASHBOARD_PERIOD: DashboardPeriod = 7;

/** Rows per list card — the Figma frames draw four. */
export const PREVIEW_ROWS = 4;

/**
 * The picker reads the institutions list, and the drilled-in institution's labs, to completion;
 * this caps a runaway at 2 000 rows per list.
 */
export const MAX_LOOKUP_PAGES = 20;

/** How long the picker waits for typing to settle before it asks `GET /api/Dashboard/scopes`. */
export const SCOPE_SEARCH_DEBOUNCE_MS = 250;

/** Labs per search answer — the endpoint's own default (1..50). */
export const SCOPE_SEARCH_LIMIT = 20;

/** A search answer is reused for a minute, so going back to an earlier term costs no request. */
export const SCOPE_SEARCH_STALE_MS = 60_000;

/** One retry: a failed lab search should reach its Retry button in seconds, not after three. */
export const SCOPE_SEARCH_RETRIES = 1;

/** TanStack Query's own default, kept for every failure a retry could still fix. */
export const LOOKUP_RETRIES = 3;

/** One retry: a dead API should turn the status pill red in seconds, not after three back-offs. */
export const STATUS_RETRIES = 1;

/** The second page — the first one has already told `fetchAllPages` how many there are. */
export const SECOND_PAGE = 2;

export const FULL_PERCENT = 100;

/**
 * The alert queue (HS-1541/HS-1542): an alert is an open service request of one of these types,
 * read by severity — Repair Critical/High first, then Repair Medium, then everything else, newest
 * first within each rank (the backend's `sortBy=severity`).
 */
export const ALERT_REQUEST_TYPES = ['Repair', 'Support'] as const;
export const ALERT_REQUEST_STATUS = 'New';
export const ALERT_SORT_BY = 'severity';
